import { Store } from '../../types/company';
import { createApiRequest } from '../../utils/apiUtils';

/**
 * リフレッシュトークンを使って新しいアクセストークンを取得
 */
export async function refreshAccessToken(): Promise<string> {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) {
    throw new Error('No refresh token found.');
  }

  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/refresh`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken }),
  });

  if (!response.ok) {
    throw new Error('Failed to refresh access token.');
  }

  const data = await response.json();
  const newAccessToken = data.accessToken;
  if (!newAccessToken) {
    throw new Error('No accessToken in refresh response.');
  }

  localStorage.setItem('accessToken', newAccessToken);

  // スライディング更新（rotation）: BE が新 refreshToken を返した場合は保存し、
  // 有効期限の窓もスライドさせる（authApi.persistSession と同じ 7 日）。ADR 0064。
  // 旧 BE（refreshToken 欠落）は従来どおり accessToken のみ更新で動作する（後方互換）。
  if (typeof data.refreshToken === 'string' && data.refreshToken) {
    const TOKEN_EXPIRATION_DAYS = 7;
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem(
      'tokenExpiration',
      (Date.now() + TOKEN_EXPIRATION_DAYS * 24 * 60 * 60 * 1000).toString()
    );
  }

  return newAccessToken;
}

interface CompanyResponse {
  name: string;
  stores: Store[];
}

/**
 * 会社情報を取得するAPI
 */
export async function fetchCompanyAPI(): Promise<CompanyResponse> {
  const clerkId = localStorage.getItem('clerk_id');
  if (!clerkId) {
    throw new Error('Unauthorized: No clerk_id found.');
  }

  const response = await createApiRequest<CompanyResponse>(`/clerk/${clerkId}`, {
    method: 'GET',
    requiresAuth: true,
    maxRetries: 3,
  });

  if (!response) {
    throw new Error('No data received from server');
  }

  return response;
}
